export default "__VITE_ASSET__CtOCfMC3__"